import { Form, Select, Modal, Switch, Input } from 'antd';
import { authFetch } from '../../../../common/request/authFetch';
import { customRequest } from '../../../../common/request/customRequest';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useState } from 'react';
import TableLZM from '../../../components/design/table/TableLZM';
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import { Batch, BatchView, Term } from '../../menuUsers/keywords/entity/TermUtils';
import { DrawerPanelTitle, modalPanelStyles } from '../../common/Drawers/DrawerPanelTitle';



export const BatchesModal = ({
    visible,
    onFinish,
    setUpdateData,
    updateData
}: any) => {

    const [batches, setBatches] = useState<any>([]);
    
    useFetch(`${process.env.REACT_APP_API}/tech/services/batches`, {}, [updateData], (data) => {
        setBatches(data);    
    });

    const launchBatch = async (project: string, term: string) => {    

        const data = {			
			project: project,
			term: term,
		};	
        await customRequest(`${process.env.REACT_APP_API}/tech/services/batch/launch_project`, { method: 'POST', data: data });
      }    
    
      const collectBatch = async (project: string, term: string) => {    

        const data = {			
			project: project,
			term: term,
		};	
        await customRequest(`${process.env.REACT_APP_API}/tech/services/batch/collect_project`, { method: 'POST', data: data });
      }

    const columns = [        
        {
          title: 'Project',
          key: 'project',
          dataIndex: 'project'

        },
        {
            title: 'keyword',
            key: 'term',
            dataIndex: 'term'  
        },        
        {
            title: 'batch',
            key: 'batch',
            render: (text: string, record: any) => (
                <BatchView kw={record}/> 
            )
        },   
        {
            title: 'lastExecution',
            key: 'lastExecution',
            render: (text: string, record: any) => (
                <div>{record.batch.lastExecution}</div>
            )
        },     
        {
            title: '',            
            dataIndex: 'term',
            render: (text: string, record: any) => (
                <div style={{display:'flex', gap:'20px'}}>
                    <ButtonLZ color='yellow' size='small' onClick={() => { launchBatch(record.project, record.term) }}>Lanzar</ButtonLZ>
                    <ButtonLZ color='yellow' size='small' onClick={() => { collectBatch(record.project, record.term) }}>Obtener Resultados</ButtonLZ>
                </div>                
              )
        },        
        
    ]
      
    return (

        <Modal
            open={visible}
            footer={false}
            onCancel={onFinish}
            width={'60%'}
            {...modalPanelStyles}
            title={<DrawerPanelTitle title="Batches" />}
        >
            {batches && <TableLZM columns={columns} dataSource={batches} rowKey={'id'} loading={false} />}
        </Modal>
    )
}

